import React, { useEffect, useState } from "react";
import { Table, Spinner, Alert, Input, Button } from "reactstrap";
import axiosInstance from "../../request";
import { URL } from "../../api";

const PAGE_SIZE = 10;

const LoanOutstandingReporting = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  // Search
  const [searchBy, setSearchBy] = useState("");
  const [searchText, setSearchText] = useState("");

  // Pagination
  const [page, setPage] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  // =========================
  // FETCH DATA (PAGINATED)
  // =========================
  const fetchDisbursals = async (pageNo = 0) => {
    setLoading(true);
    setError("");

    try {
      const params = {
        page: pageNo,
        size: PAGE_SIZE,
      };

      if (searchBy && searchText) {
        params[searchBy] = searchText;
      }

      const res = await axiosInstance.get(
        URL.DISBURSAL_OUTSTANDING_REPORTING,
        { params }
      );

      setData(res.data.content || []);
      setTotalPages(res.data.totalPages || 0);
      setPage(pageNo);
    } catch (err) {
      console.error(err);
      setError("Failed to fetch disbursal reporting data.");
      setData([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchDisbursals(0);
  }, []);

  // =========================
  // SEARCH
  // =========================
  const handleSearch = () => {
    fetchDisbursals(0);
  };

const exportToExcel = () => {
  const params = { export: true };
  if (searchBy && searchText) {
    params[searchBy] = searchText;
  }

  axiosInstance.get(URL.DISBURSAL_OUTSTANDING_REPORTING, {
    params,
    responseType: "blob",
  })
  .then((res) => {
    const url = window.URL.createObjectURL(new Blob([res.data]));
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", "Loan_Outstanding_Report.xlsx");
    document.body.appendChild(link);
    link.click();
    link.remove();
  })
  .catch(() => {
    alert("Failed to export Excel");
  });
};


  return (
    <>
      {/* ================= SEARCH + EXPORT ================= */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          gap: "10px",
          marginBottom: "20px",
          alignItems: "flex-end",
        }}
      >


        <Button
          color="success"
          onClick={exportToExcel}
          style={{ fontSize: "12px", fontWeight: "500", height: "38px" }}
        >
          Export to Excel
        </Button>
      </div>

      {loading && <Spinner color="primary" />}
      {error && <Alert color="danger">{error}</Alert>}

      {!loading && !error && (
        <>
          <div style={{ overflowX: "auto" }}>
            <Table bordered striped hover responsive style={{ whiteSpace: "nowrap" }}>
              <thead>
                <tr>
                  <th>S.No.</th>
                  <th>Customer ID</th>
                  <th>Customer Name</th>
                  <th>Loan ID</th>
                  <th>Fintech Name</th>
                  <th>Product</th>
                  <th>Repayment Type</th>
                  <th>Disbursal Amount</th>
                  <th>Disbursal Date</th>
                  <th>Payout ID</th>
                  <th>Total Outstanding Principal</th>
                  <th>Total Outstanding Interest</th>
                  <th>Total Outstanding EMI</th>
                  <th>Total Fees</th>
                  <th>Total OverDue Amount</th>
                  <th>Loan Amount</th>
                  <th>Emi Amount</th>
                </tr>
              </thead>
              <tbody>
                {data.length ? (
                  data.map((row, i) => (
                    <tr key={i}>
                      <td>{page * PAGE_SIZE + i + 1}</td>
                      <td>{row.customer_id}</td>
                      <td>{row.customer_name}</td>
                      <td>{row.loan_id}</td>
                      <td>{row.fintech_name}</td>
                      <td>{row.product_name}</td>
                      <td>{row.repayment_type_name}</td>
                      <td>₹{row.disbursal_amount?.toFixed(2)}</td>
                      <td>{row.disbursal_date}</td>
                      <td>{row.payout_id}</td>
                      <td>₹{row.totalOutstandingPrincipal?.toFixed(2) || "0.00"}</td>
                      <td>₹{row.totalOutstandingInterest?.toFixed(2) || "0.00"}</td>
                      <td>₹{row.totalOutstandingEmiAmount?.toFixed(2) || "0.00"}</td>
                      <td>₹{row.totalFees?.toFixed(2) || "0.00"}</td>
                      <td>₹{row.totalOverdueAmount?.toFixed(2) || "0.00"}</td>
                      <td>₹{row.loan_amount?.toFixed(2) || "0.00"}</td>
                      <td>₹{row.emi_amount?.toFixed(2) || "0.00"}</td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="16" style={{ textAlign: "center" }}>
                      No data found.
                    </td>
                  </tr>
                )}
              </tbody>
            </Table>
          </div>

          {/* ================= PAGINATION ================= */}
          {totalPages > 1 && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "10px",
                marginTop: "10px",
              }}
            >
              <Button
                size="sm"
                disabled={page === 0}
                onClick={() => fetchDisbursals(page - 1)}
              >
                Prev
              </Button>

              <span style={{ fontSize: "12px" }}>
                Page {page + 1} of {totalPages}
              </span>

              <Button
                size="sm"
                disabled={page + 1 >= totalPages}
                onClick={() => fetchDisbursals(page + 1)}
              >
                Next
              </Button>
            </div>
          )}
        </>
      )}
    </>
  );
};

export default LoanOutstandingReporting;
